import { EventAdapter } from '@/5_entities/Event'
import type { Pagination } from '@/6_shared/model'
import type { Venue, VenueDTO } from './type'

export class VenueAdapter implements Venue {
  public id: Venue['id']
  public title: Venue['title']
  public address: Venue['address']
  public image: Venue['image']
  public coords: Venue['coords']
  public description: Venue['description']
  public category: Venue['category']
  public repertoire: Venue['repertoire']
  public repertoireEventsCount: Venue['repertoireEventsCount']
  public repertoirePagination: Venue['repertoirePagination']
  public cityName: Venue['cityName']
  public availableDates: Date[]

  constructor(venue: VenueDTO) {
    this.id = venue.id
    this.title = venue.title
    this.address = venue?.address
    this.image = venue.media?.posterImage
    this.coords = venue.address?.coords
    this.description = venue?.fullDescription
    this.category = venue?.category
    this.repertoire = Array.isArray(venue.repertoire?.items)
      ? this._setRepertoire(venue.repertoire)
      : []
    this.repertoireEventsCount = venue.repertoire?.pagination.totalCount || 0
    this.repertoirePagination = venue?.repertoire?.pagination
    this.cityName = venue.cityName
    this.availableDates = venue?.repertoire?.availableDates
      ? this._setAvailableDates(venue.repertoire.availableDates)
      : []
  }

  private _setAvailableDates(dates: string[]) {
    return dates.map((date) => new Date(date))
  }

  private _filterRepertoire(repertoire: NonNullable<Venue['repertoire']>) {
    return repertoire.forEach((item) => {
      item.seances = item.seances?.filter((seance) => seance?.venueId === this.id) ?? []
    })
  }

  private _setRepertoire(repertoire: VenueDTO['repertoire']) {
    const repertoireToSet = repertoire?.items.map((item) => new EventAdapter(item.object)) ?? []
    this._filterRepertoire(repertoireToSet)

    return repertoireToSet
  }

  public updateRepertoire(repertoire: VenueDTO['repertoire']) {
    this.repertoire = this._setRepertoire(repertoire)
  }

  public updatePagination(pagination?: Pagination) {
    this.repertoirePagination = pagination
  }

  public addRepertoireNextPage(newRepertoire: VenueDTO['repertoire']) {
    if (!newRepertoire) return

    const { pagination, items } = newRepertoire

    this.repertoirePagination = pagination
    const events = items.map((item) => new EventAdapter(item.object)) ?? []
    events.forEach((event) => this.repertoire.push(event))
  }
}
